import {
  ADD_NEW_PROFILE,
  ADD_PROFILE_ERROR,
  ADD_PROFILE_SUCCESS,
  DELETE_PROFILE,
  DELETE_PROFILE_SUCCESS,
  DELETE_WORK_REPORT,
  DELETE_WORK_REPORT_SUCCESS,
  PROFILE_DATA_ERROR,
  PROFILE_DATA_SUCCESS,
  TRACK_CATEGORY_VALUE_SUCCESS,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_WORK_REPORT,
  UPDATE_WORK_REPORT_SUCCESS,
} from "./actiontype"

const initialState = {
  timeSheetReportSuccessList: null,
  timeSheetReportError: null,
  projectListSuccess: null,
  projectListError: null,
  addprofile: null,
  updateprofile: null,
  deleteprofile: null,
  deleteprofileSuccess: null,
  updatereports:null,
  updatereportsError:null
}

const trackprofile = (state = initialState, action) => {
  switch (action.type) {
    case TRACK_CATEGORY_VALUE_SUCCESS:
      return {
        ...state,
        maincategorylist: action.payload.category,
        subCategorylist: action.payload.subCategory,
        userList: action.payload.users,
      }
      break

    case PROFILE_DATA_SUCCESS:
      return {
        ...state,
        profileData: action.payload,
        profileDataError: null,
      }
      break

    case PROFILE_DATA_ERROR:
      return { ...state, profileDataError: action.payload }
      break
    case ADD_NEW_PROFILE:
      return {
        ...state,
        addprofile: null,
        addprofileError: null,
      }
      break
    case ADD_PROFILE_SUCCESS:
      return {
        ...state,
        addprofile: action.payload,
        addprofileError: null,
      }
      break

    case ADD_PROFILE_ERROR:
      return { ...state, addprofileError: action.payload }
      break

    case UPDATE_PROFILE:
      return {
        ...state,
        updateprofile: null,
        updateprofileError: null,
      }
      break
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        updateprofile: action.payload,
        updateprofileError: null,
      }
      break

    case DELETE_PROFILE:
      return {
        ...state,
        deleteprofileSuccess: action.payload,
      }
      break
    case DELETE_PROFILE_SUCCESS:
      return {
        ...state,
        deleteprofileSuccess: action.payload,
      }
      break

      //update report timesheet user
      case UPDATE_WORK_REPORT:
        return {
          ...state,
          updatereports: null,
          updatereportsError: null,
        }
        break
      case UPDATE_WORK_REPORT_SUCCESS:
        return {
          ...state,
          updatereports: action.payload,
          updatereportsError: null,
        }
        break
        
    default:
      return { ...state }
      break
  }
  return state
}

export default trackprofile
